module.exports = __webpack_public_path__ + "img/940.7e2ee323.jpg";